import Header from './Header'

import './style.scss'

export { Header }
export default Header
